import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Set the `}<a parentName="p" {...{
        "href": "https://developer.apple.com/ios/universal-links/"
      }}>{`iOS Universal Link`}</a>{` that's used to call your app after an `}<strong parentName="p">{`out-of-band (OOB)`}</strong>{` authentication.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      